module.exports = __webpack_public_path__ + "c53aa43e9929a9d68b297eb32c5a27a3.jpg";


//////////////////
// WEBPACK FOOTER
// ./www/assets/img/asistente-pagos.jpg
// module id = 194
// module chunks = 0